<template>
	<div class="wrapper px-3 mx-auto">
		<div class="box has-text-centered">
			<img src="@/assets/images/gifs/crying-man.gif"/>
			<br />
			<span class="bold-text">Oh no! You’re out of leads.</span>
			<br />
			<span>
				To claim more jobs, top up your account by clicking below.
			</span>
			<br/><br/>
			<button class="button is-primary" @click="close(true)">Get More Leads</button>
		</div>
	</div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { closeModal } from "@/utils/mixins";

export default defineComponent({
	mixins: [closeModal]
})
</script>

<style scoped>
.wrapper {
	max-width: 300px;
}

img {
	max-width: 150px;
}
</style>
